import { render, staticRenderFns } from "./bulma_pictureupload.vue?vue&type=template&id=48986b16&scoped=true"
import script from "./bulma_pictureupload.vue?vue&type=script&lang=js"
export * from "./bulma_pictureupload.vue?vue&type=script&lang=js"
import style0 from "./bulma_pictureupload.vue?vue&type=style&index=0&id=48986b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48986b16",
  null
  
)

export default component.exports